import { memo } from 'react'
import { Card, CardContent, Box, Button } from '@mui/material'
import { Tile } from './common/service-title'
import { TILES } from '../config'

function PartnersGrid({ onApply }) {
  return (
    <Card sx={{ height: '100%', minHeight: '360px' }}>
      <CardContent
        sx={{
          position: 'relative',
          height: '100%',
          minHeight: '360px',
          p: 0,
          pb: 0,
          boxSizing: 'content-box',
          '&:last-child': {
            pb: 0,
          },
        }}>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
            gridAutoRows: 'minmax(210px, auto)',
            alignItems: 'stretch',
            justifyContent: 'center',
            gap: 0,
            width: '100%',
            height: '100%',
          }}>
          {TILES.map((tile) => (
            <Box
              key={tile.key}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'stretch',
              }}>
              <Tile {...tile} />
            </Box>
          ))}
        </Box>

        <Button
          onClick={onApply}
          sx={{
            position: 'absolute',
            left: '50%',
            top: '50%',
            transform: 'translate(-50%, -50%)',
            zIndex: 2,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '8px',
            width: '145px',
            padding: '14px 20px',
            borderRadius: '4px',
            border: '1px solid var(--primary-500-main, #6366F1)',
            backgroundColor: '#00B6B0',
            boxShadow: '0 2px 6px 0 rgba(16, 24, 40, 0.06)',
            color: '#020202',
            fontFamily: 'Inter, sans-serif',
            fontSize: '14px',
            fontWeight: 700,
            lineHeight: '20px',
            textTransform: 'none',
            '&:hover': {
              backgroundColor: '#00a19b',
            },
          }}>
          Apply Now
        </Button>
      </CardContent>
    </Card>
  )
}

export default memo(PartnersGrid)
